export enum ACCOUNT_TYPE {
  // eslint-disable-next-line no-unused-vars
  MEDICAL = 'MEDICAL',
  // eslint-disable-next-line no-unused-vars
  ADULT = 'ADULT',
}
